import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import GlobalSearchState from 'flarum/forum/states/GlobalSearchState';

export default function addFeaturedFilter() {
  extend(IndexPage.prototype, 'navItems', function (items) {
    const params = app.search.stickyParams();

    items.add(
      'featured',
      <LinkButton href={app.route('featured', params)} icon={app.forum.attribute('tanka-connector.featuredIcon') || 'fas fa-magic'}>
        {app.translator.trans('tanka-connector.forum.index.featured_link')}
      </LinkButton>,
      80
    );
  });

  extend(IndexPage.prototype, 'setTitle', function () {
    if (app.current.get('routeName') === 'featured') {
      app.setTitle(app.translator.trans('tanka-connector.forum.featured.meta_title_text'));
    }
  });

  extend(GlobalSearchState.prototype, 'params', function (params) {
    // We can't set `q` here directly, as that would make the search bar
    // think that text has been entered, and display the "clear" button.
    params.onFeatured = app.current.get('routeName') === 'featured';
  });

  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (this.params.onFeatured) {
      params.filter ||= {};

      if (params.filter.q) {
        params.filter.q += ' is:featured';
      } else {
        params.filter.featured = 'true';
      }
    }
  });
}
